/**
 * 原始消息
 * @param message 消息内容
 * @returns
 */
const Message = message => {
  //@ts-ignore
  return ElMessage({
    showClose: false,
    message
  });
};
/**
 * 成功消息
 * @param message 消息内容
 * @returns
 */
const successMessage = message => {
  //@ts-ignore
  return ElMessage({
    showClose: false,
    message,
    type: "success"
  });
};
/**
 * 警告消息
 * @param message 消息内容
 * @returns
 */
const warnMessage = message => {
  //@ts-ignore
  return ElMessage({
    showClose: false,
    message,
    type: "warning"
  });
};
/**
 * 失败消息
 * @param message 消息内容
 * @returns
 */
const errorMessage = message => {
  //@ts-ignore
  return ElMessage({
    showClose: false,
    message,
    type: "error"
  });
};
const confirm = async (message, type, title) => {
  //@ts-ignore
  const confirmResult = await ElMessageBox.confirm(message, title ? title : '提示', {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    type: type
  }).catch(err => err);
  return confirmResult;
};
export { Message, successMessage, warnMessage, errorMessage, confirm };